import React from 'react';
import { ButtonType } from '../../../SharedComponents/Button/ButtonType';
import CustomButton from '../../../SharedComponents/Button/CustomButton';
import AppContainer from '../../../SharedComponents/Container/AppContainer';
import BodyContainer from '../../../SharedComponents/Container/BodyContainer';
import Header from '../../../SharedComponents/Header/HeaderRefactor';
import BulletList from '../../../SharedComponents/List/BulletList';
import TopProgressBar from '../../../SharedComponents/TopProgressBar/TopProgressBar';
import CustomTypography, {
    TypographyType,
} from '../../../SharedComponents/Typography/CustomTypography';
import '../HearingAssessmentStyle.scss';
import useHearingAssessmentStartHandler from './HearingAssessmentStartHandler';
import useHearingAssessmentStartResource from './HearingAssessmentStartResource';

export default function HearingAssessmentStart(): React.ReactElement {
    const { startHLAA, getTopProgress } = useHearingAssessmentStartHandler();
    const {
        header,
        instructionTitle,
        instruction,
        instructionSteps,
        startButton,
    } = useHearingAssessmentStartResource();

    return (
        <AppContainer>
            <TopProgressBar progress={getTopProgress()} />
            <Header headerContent={header} />
            <BodyContainer>
                <CustomTypography
                    type={TypographyType.notoSansSubHeading}
                    text={instructionTitle.text}
                    textAlign="center"
                    id={instructionTitle.id}
                    className={'hlaaTitle'}
                />
                <CustomTypography
                    type={TypographyType.notoSansBody}
                    text={instruction.text}
                    textAlign="left"
                    id={instruction.id}
                    className={'hlaaTitle'}
                />
                <BulletList
                    id={instructionSteps.id}
                    bulletItems={instructionSteps.text.split('|')}
                />
            </BodyContainer>
            <CustomButton
                id={startButton.id}
                buttonType={ButtonType.PrimaryLoading}
                onClick={startHLAA}
            >
                {startButton.text}
            </CustomButton>
        </AppContainer>
    );
}
